// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"05c5aae6","893":"b6d93b77"}[chunkId] + ".chunk.js";
};